export const ApiCategories = [
  {
    title: 'Jeans',
    src: 'https://images.pexels.com/photos/1082529/pexels-photo-1082529.jpeg',
  },
  {
    title: 'Jackets',
    src: 'https://images.pexels.com/photos/6770028/pexels-photo-6770028.jpeg',
  },
  {
    title: 'Styles Tee Shirts',
    src: 'https://images.pexels.com/photos/8346230/pexels-photo-8346230.jpeg',
  },
];
